



























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IActivityStatus as ITV } from "@/@types/admin/activity-status";

import RoomCard from "./room-card.vue";

interface IRoomLeavel {
  [x: string]: Array<Array<string>>;
}

@Component({ components: { RoomCard } })
export default class RoomList extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) levels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) types!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) statuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) tvs!: Array<ITV>;
  @Prop({ type: Array, default: () => [] }) devices!: Array<ITV>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  room_id = "";
  waif: Array<IRoom> = [];

  get room(): IRoom | null {
    const room = this.rooms.find((el) => el._id == this.room_id);
    return room ? room : null;
  }

  get roomList(): IRoomLeavel {
    const levels: IRoomLeavel = {};
    this.waif = [];
    const levels_id: Array<string> = [];
    this.levels.forEach((el) => levels_id.push(el._id));
    const maximus: { [x: string]: { x: string; y: string } } = {};
    let maxx = 0;
    this.rooms.forEach((el) => {
      if (
        el.level &&
        el.position &&
        el.position.x !== null &&
        el.position.x !== undefined &&
        el.position.x !== "" &&
        el.position.y !== null &&
        el.position.y !== undefined &&
        el.position.y !== "" &&
        levels_id.includes(el.level)
      ) {
        const x =
          maximus[el.level] && maximus[el.level].x
            ? parseInt(maximus[el.level].x) < parseInt(el.position.x)
              ? el.position.x
              : maximus[el.level]?.x
            : String(0);
        const y =
          maximus[el.level] && maximus[el.level].y
            ? parseInt(maximus[el.level].y) < parseInt(el.position.y)
              ? el.position.y
              : maximus[el.level]?.y
            : String(0);
        maximus[el.level] = { x, y };

        maxx = maxx < parseInt(x) ? parseInt(x) : maxx;
      }
    });

    if (!Object.keys(maximus).length) return levels;

    this.levels.forEach((el) => {
      const y = maximus[el._id] ? parseInt(maximus[el._id].y) : 0;
      const x = maximus[el._id] ? parseInt(maximus[el._id].x) + 1 : 0;

      levels[el._id] = new Array(y ? y + 1 : 0);
      for (let i = 0; i < levels[el._id].length; i++) {
        this.$set(levels[el._id], i, new Array(x ? x : 0).join("*").split(""));
      }
    });

    this.rooms.forEach((el) => {
      if (
        !el.level ||
        !el.position ||
        el.position.x === null ||
        el.position.x === undefined ||
        el.position.x === "" ||
        el.position.y === null ||
        el.position.y === undefined ||
        el.position.y === "" ||
        !levels_id.includes(el.level)
      )
        this.waif.push(el);
      else {
        const x = parseInt(el.position.x);
        const y = parseInt(el.position.y);

        let j = 0;
        while (!levels[el.level][y]) {
          if (j > 5) {
            this.dangerError();
            break;
          }
          j++;
          levels[el.level].push([]);
        }

        let i = 0;
        while (!levels[el.level][y][x]) {
          if (i > 250) {
            this.dangerError();
            break;
          }
          i++;
          levels[el.level][y].push("*");
        }
        levels[el.level][y][x] = JSON.parse(JSON.stringify(el._id));
      }
    });
    return levels;
  }

  openRoom(id: string): void {
    this.room_id = id;
  }

  dangerError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "error",
    });
  }

  getTypeColor(room: IRoom): string {
    const type = this.types.find((el) => el._id == room.type);
    return type ? type.color : "";
  }

  cellStyle(room: IRoom): Record<string, string> {
    const c = this.getTypeColor(room);
    if (!c) return {};
    return {
      background: `${c}1f`,
      "border-color": `${c}59`,
      color: "#333333",
    };
  }

  cellStyleById(id: string): Record<string, string> {
    const room = this.rooms.find((el) => el._id == id);
    if (!room) return {};
    return this.cellStyle(room);
  }

  cellTitle(room: IRoom): string {
    const parts: string[] = [room.name];
    const typeName = this.getType(room.type);
    if (typeName) parts.push(typeName);
    if (room.area) parts.push(`${room.area}m²`);
    const statusName = this.getRoomStatus(room.status);
    if (statusName) parts.push(statusName);
    return parts.join(" | ");
  }

  cellTitleById(id: string): string {
    const room = this.rooms.find((el) => el._id == id);
    return room ? this.cellTitle(room) : "";
  }

  getLevelName(id: string): string {
    const level = this.levels.find((el) => el._id == id);
    return level ? this.$getLocale(level.name) : "-";
  }

  getType(type: string | undefined): string {
    const t = this.types.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? type : "";
  }

  getRoomStatus(type: string | undefined): string {
    if (!type) return "";
    const t = this.statuses.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? type : "";
  }

  getRoom(room_id: string): Partial<IRoom> {
    const room = this.rooms.find((el) => el._id == room_id);
    return room ? room : { _id: room_id };
  }
}
